<div class="container">
  <div class="col-md-12 mb-md-0 mb-12">

    <!-- Grid row -->
    <div class="row">
      <div class="col-md-5">
        <label class="title-wellcome">
          ¡Bienvenido a Loggiapp!
        </label>
      </div>
      <div class="col-md-7">
        <div class="row">
          <h4 class="text-bold">
            Activa tu cuenta
          </h4>
        </div>
        <div class="row">
          Para seguir con las regulaciones legales y activar tu cuenta tendrás que subir los siguientes documentos <span
            class="text-bold">con vigencia menor a un año:</span>
        </div>
        <br>
        <div class="row document-types">
          <!--  -->


          <div class="col-sm-6" *ngFor="let file of typeFiles; let i = index">
            <label class="document-type">
              <input type="file" *ngIf="!file.fileRegistered" [attr.id]="'file' + i" class="display-none"
                (change)="handleFileInput($event, i)">
              <div class="icon-type"
                [ngClass]="{'file-loaded': (file.fileRegistered || (file.uploadProgress | async) === 100)}">
                <img [attr.for]="'file' + i" *ngIf="(!file.fileRegistered && (file.uploadProgress | async) !== 100)"
                  src="/assets/svg/icons/icon-upload.svg" alt="">
                <img *ngIf="(file.fileRegistered || (file.uploadProgress | async) === 100)"
                  src="/assets/svg/icons/icon-correct.svg" alt="">
              </div>
              <div class="delete-container" *ngIf="file.fileRegistered">
                <img (click)="deleteFile(i)" src="/assets/svg/icons/icon-delete.svg" alt="">
              </div>
              <div class="data-type">
                <label class="label-field title-letter">{{file.title}}</label>
                <br>
                <label *ngIf="(file.fileRegistered || (file.uploadProgress | async) === 100)"
                  class="label-field label-file">
                  <a class="file-name-container" *ngIf="file.name" (click)="downloadFile(file)" target="_blank">
                    <i class="fas fa-paperclip"></i>
                    <span class="file-name" title="{{file.name}}">{{file.name}}</span>
                    <span class="file-size" *ngIf="file.size" title="{{file.size}}">{{file.size}}</span>
                  </a>
                </label>
                <span *ngIf="(!file.fileRegistered && !(file.uploadProgress))" [attr.for]="'file' + i"
                  class="label-load-file">
                  <a>Subir archivo</a>
                </span>
                <div *ngIf="(file.uploadProgress) && (file.uploadProgress | async) !== 100">
                  <mat-progress-bar [value]="file.uploadProgress | async">
                  </mat-progress-bar>
                </div>
              </div>
            </label>
          </div>

        </div>
        <br><br>
        <!-- <div class="row actions-buttons">
          <mat-card-actions>
            <button mat-raised-button color="primary" (click)="sendUploadsFiles()">Enviar documentos</button>
          </mat-card-actions>
        </div> -->


      </div>
    </div>
    <div class="row">

    </div>

  </div>
</div>